import { AUTH_MODE } from '../config/endpoints.js';

const isCognitoMode = () => AUTH_MODE === 'cognito' || AUTH_MODE === 'hybrid';
const isLegacyMode = () => AUTH_MODE === 'legacy';

export { isCognitoMode, isLegacyMode };
